export const accessToken = () => {
  return localStorage.accessToken || sessionStorage.accessToken
}

export const refreshToken = () => {
  return localStorage.refreshToken || sessionStorage.refreshToken
}

export const setAccessToken = (token, remember) => {
  if (remember) {
    localStorage.setItem('accessToken', token)
  } else {
    sessionStorage.setItem('accessToken', token)
  }
}

export const setRefreshToken = (token, remember) => {
  if (remember) {
    localStorage.setItem('refreshToken', token)
  } else {
    sessionStorage.setItem('refreshToken', token)
  }
}